// Live stats for the track recorder. Mirrors mobile utils/trackStats.ts (web keeps distance in km).

// activities where people think in pace (min/km) rather than speed
const PACE_CONTEXTS = ['running', 'nordicWalking'];

export const usesPace = context => PACE_CONTEXTS.includes(context);

const pad = value => String(value).padStart(2, '0');

// "12:34" under an hour, "1:02:03" after
export const formatClock = totalSeconds => {
  const seconds = Math.max(0, Math.floor(totalSeconds || 0));
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return h ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};

export const avgSpeedKmh = (distanceKm, seconds) =>
  seconds > 0 ? Math.round((distanceKm / seconds) * 3600 * 10) / 10 : 0;

// seconds per km; null until there is enough movement to measure
export const paceFromSpeed = kmh => (kmh > 0.5 ? 3600 / kmh : null);
export const avgPace = (distanceKm, seconds) => (distanceKm >= 0.05 && seconds > 0 ? seconds / distanceKm : null);

// "5:07" per km, "--:--" when unknown or slower than an hour per km
export const formatPace = secondsPerKm => {
  if (!secondsPerKm || !isFinite(secondsPerKm) || secondsPerKm >= 3600) {
    return '--:--';
  }
  const total = Math.round(secondsPerKm);
  return `${Math.floor(total / 60)}:${pad(total % 60)}`;
};

// horizontal accuracy in metres → what the status chip shows
export const gpsQuality = accuracy => {
  if (accuracy == null) {
    return 'searching';
  }
  return accuracy <= 20 ? 'good' : 'weak';
};
